export enum IsbnOrDoi {
  ISBN = 'isbn',
  DOI = 'doi',
}

export interface RequestDigitisationIdentifier {
  value: string;
  type: IsbnOrDoi;
}
